
import React from 'react';

const Footer = () => {
    return (
        
          <footer className="footer w-full lg:max-w-7xl mx-auto bg-neutral text-neutral-content items-center p-4 flex flex-col">
            <nav className="grid-flow-col  md:place-self-center md:justify-self-end mt-12 gap-12">
              
              <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="fill-current">
                  <path
                    d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
                </svg>
              </a>
              <a href="https://www.facebook.com/faysalgub35" target="_blank" rel="noopener noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="fill-current">
                  <path
                    d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
                </svg>
              </a>
              <a href="https://github.com/Faysalgreen35" target="_blank" rel="noopener noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="fill-current">
                  <path
                    d="M12 0C5.37 0 0 5.37 0 12c0 5.302 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.608-4.042-1.608-.546-1.387-1.333-1.756-1.333-1.756-1.09-.745.083-.73.083-.73 1.204.084 1.838 1.236 1.838 1.236 1.07 1.835 2.807 1.305 3.492.997.108-.776.417-1.305.76-1.606-2.665-.305-5.467-1.334-5.467-5.93 0-1.31.467-2.383 1.235-3.223-.123-.305-.536-1.532.117-3.192 0 0 1.008-.322 3.3 1.23.957-.266 1.98-.399 3-.404 1.02.005 2.043.138 3 .404 2.29-1.552 3.298-1.23 3.298-1.23.655 1.66.242 2.887.12 3.192.77.84 1.233 1.913 1.233 3.223 0 4.61-2.806 5.624-5.48 5.92.428.368.81 1.096.81 2.213 0 1.598-.014 2.886-.014 3.282 0 .323.216.694.824.576C20.565 21.796 24 17.298 24 12c0-6.63-5.37-12-12-12z"></path>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/musnud-billah-faysal/" target="_blank" rel="noopener noreferrer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="fill-current">
                  <path
                    d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.28c-.96 0-1.72-.78-1.72-1.72s.76-1.72 1.72-1.72 1.72.78 1.72 1.72-.76 1.72-1.72 1.72zm13.5 12.28h-3v-5.6c0-3.4-4-3.1-4 0v5.6h-3v-11h3v1.5c1.396-2.586 7-2.777 7 2.476v7.024z"></path>
                </svg>
              </a>
            </nav>
            <br />
            <aside className="grid-flow-col items-center">
            <p>Copyright © ${new Date().getFullYear()} - All right reserved by Musnud Billah Faysal</p>
              {/* <p>Copyright © Musnud Billah Faysal. All rights reserved.</p> */}
            </aside>
          </footer>
        
    );
};

export default Footer;
 

// const Footer = () => {
//     return (
//         <div className=' lg:w-[1200px] mx-auto text-center ml-24'>
//           <footer className="footer w-full bg-neutral text-neutral-content items-center p-4 flex flex-col">
//           <nav className="grid-flow-col gap-4 md:place-self-center md:justify-self-end mt-12 gap-12">
//     <a>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="24"
//         viewBox="0 0 24 24"
//         className="fill-current">
//         <path
//           d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
//       </svg>
//     </a>
//     <a>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="24"
//         viewBox="0 0 24 24"
//         className="fill-current">
//         <path
//           d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
//       </svg>
//     </a>
//     <a>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="24"
//         height="24"
//         viewBox="0 0 24 24"
//         className="fill-current">
//         <path
//           d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
//       </svg>
//     </a>
//   </nav>
//   <br />
//   <aside className="grid-flow-col items-center">
     
//     <p>Copyright © Musnud Billah Faysal. All rights reserved.</p>
//   </aside>
  
// </footer> 
//         </div>
//     );
// };

// export default Footer;